import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import BrandWriteDTO from '../../../../../../types/brand/BrandWriteDTO';
import Media from '../../../../../../types/media/Media';
import { BrandService } from '../../../../services/brand.service';
import { MediaService } from '../../../../services/media.service';
import {
    SelectOrUploadMediaComponent
} from '../../media/select-or-upload-media-dialog/select-or-upload-media.component';

@Component({
    selector: 'app-update-brand-dialog',
    templateUrl: './update-brand-dialog.component.html',
    styleUrls: [ './update-brand-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        SelectOrUploadMediaComponent,
    ]
})
export class UpdateBrandDialogComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() brand: BrandWriteDTO = new BrandWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() brandUpdated: EventEmitter<BrandWriteDTO> = new EventEmitter<BrandWriteDTO>();

    constructor(private brandService: BrandService,
                private messageService: MessageService,
                private mediaService: MediaService) {
    }

    public loading = false;

    public media: Media | undefined = undefined;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue === true) {
            if (this.brand.imageId) {
                this.mediaService.getMedia(this.brand.imageId).then((media) => {
                    this.media = media;
                }).catch((error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
            } else {
                this.media = undefined;
            }
        }
    }

    get saveDisabled(): boolean {
        return !this.brand?.name || !this.brand?.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateBrand() {
        this.loading = true;
        if (this.media) {
            this.brand.imageId = this.media.id;
        } else {
            this.brand.imageId = undefined;
        }
        this.brandService.updateBrand(this.brand).then(() => {
            this.brandUpdated.emit(this.brand);
            this.close();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }

}
